<template>
  <section class="section-padding">
    <div class="row">
      <div class="col-md-6 col-12" ref="qrCodeHtml">
        <div class="text-center">
          <img src="/static/img/thai-qr-payment.png" alt="">
          <div class="parent">
            <qrcode-vue :value="value" class="image1" :size="size" level="H" v-if="value"></qrcode-vue>
            <img src="/static/img/thai-qr-payment-logo-sm.png" width="40" alt="" class="image2">
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12">
        <div class="card">
          <div class="card-body">
            <h3>Generate QR Code</h3>
            <div class="form-group">
              <label for="amount">Amount</label>
              <input type="text" class="form-control" id="amount" v-model="amount">
            </div>
            <div class="form-group" v-if="apiToken">
              <label for="apiToken">Token</label>
              <input type="text" class="form-control" id="apiToken" v-model="apiToken">
            </div>
            <button class="btn btn-info btn-block btn-lg mt-4" @click="genQrCode()">Gen Qr Code</button>
          </div>
        </div>
        <button class="btn btn-primary" @click="saveScreenshot()">Take Screenshot</button>
        <div class="p-4" v-if="responseData">
          {{ responseData }}
        </div>

        <div class="card mt-4">
          <div class="card-body">
            <h3>Check Generated QR Code Status</h3>
            <div class="form-group">
              <label for="generatedId">Generated ID</label>
              <input type="text" class="form-control" id="generatedId" v-model="origin_partner_txn_uid">
            </div>
            <div class="mb-3">
              <button class="btn btn-primary btn-block btn-lg" @click="performQrApi('inquiry')">Check Qr Code</button>
            </div>
            <div class="mb-3">
              <button class="btn btn-danger btn-block btn-lg" @click="performQrApi('void')">Void</button>
            </div>
            <div class="mb-3">
              <button class="btn btn-warning btn-block btn-lg" @click="performQrApi('cancel')">Cancel</button>
            </div>
            <div class="py-3" v-if="responseQrCodeStatus">
              {{ responseQrCodeStatus }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import QrcodeVue from 'qrcode.vue'
  import axios from 'axios'
  import html2canvas from 'html2canvas'
  import moment from 'moment-timezone'

  export default {
    components: {
      QrcodeVue
    },
    data () {
      return {
        partner_txn_uid: null,
        origin_partner_txn_uid: null,
        amount: 1000,
        value: 'https://google.com',
        size: 240,
        responseData: null,
        responseQrCodeStatus: null,
        apiToken: null,
        expireTime: null,
        output: null
      }
    },
    computed: {
      ...mapState('payment', ['qrPaymentId'])
    },
    methods: {
      saveScreenshot () {
        const el = this.$refs.qrCodeHtml
        html2canvas(el).then(canvas => {
          const dateTime = moment().format('YYYY_MM_DD_h_mm_ss')
          const fileName = `QRCode${dateTime}.png`
          console.log('fileName', fileName)
          const link = window.document.createElement('a')
          link.setAttribute('href', canvas.toDataURL())
          link.setAttribute('download', fileName)
          link.click()
        }).catch((error) => {
          console.log('ERROR SAVING IMAGE', error)
        })
      },
      genQrCode () {
        const url = '/qr-payments/create-qr-code'
        const params = {
          order_id: 1,
          payment_for: 'normal',
          amount: Number(this.amount)
        }
        axios.post(url, params)
          .then(res => {
            const response = res.data
            console.log('response data', response)
            if (response) {
              this.responseData = response
              this.value = response.qrCode
              this.origin_partner_txn_uid = response.partnerTxnUid
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      performQrApi (action) {
        let url = '/qr-payments/' + action
        const params = {orig_partner_txn_uid: this.origin_partner_txn_uid}
        axios.post(url, params)
          .then(res => {
            const response = res.data
            if (response) {
              this.responseQrCodeStatus = response
              console.log('inquery response', response)
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
</script>

<style>
  .parent {
    position: relative;
    margin: auto;
    top: 0;
    left: 0;
    width: 280px;
    height: 285px;
    border: 1px solid #0e3d67;
  }

  .image1 {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .image2 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/user/payment/QrCodePayment.vue